import { ProductPrice } from '~/Product';

import CalculatedPrice from './CalculatedPrice';

export default class ExFactoryReferencePrice {
	sourcePrice: ProductPrice;

	calculatedPrice: CalculatedPrice;

	selected: boolean;

	constructor(sourcePrice: ProductPrice, calculatedPrice: CalculatedPrice, selected: boolean) {
		this.sourcePrice = sourcePrice;
		this.calculatedPrice = calculatedPrice;
		this.selected = selected;
	}
}
